"use strict";
angular
    .module("newPageScrollPicModule", [])
    .factory("newPageScrollPic", [
        "$modal",
        function ($modal) {
            return {
                //新开一个弹窗 里面是一个指令
                alertScrollPic: function (items) {
                    var modalInstance = $modal.open({
                        templateUrl: "./utils/newPageScrollPic/newPageScrollPic.html",
                        windowClass: "createExplosionCtrl",
                        backdrop: false,
                        keyboard: false,
                        controller: "newPageScrollPicCtrl",
                        resolve: {
                            items: function () {
                                return {
                                    items
                                };
                            },
                        },
                    });
                },
            };
        },
    ])
    .controller("newPageScrollPicCtrl", [
        "$scope",
        "$modalInstance",
        "items",
        function ($scope, $modalInstance, items) {
            initStatus();
            initData();

            function initStatus() {
                $scope.item = items.items;
            }

            function initData() {
                // console.log($scope.item.imgurl);
            }

            $scope.cancel = function () {
                $modalInstance.close();
            };
        },
    ]);
